import { useEffect } from 'react';
import { useRouter } from 'next/compat/router';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';

import {
  DASHBOARD_PATH,
  FACILITY_PATHS,
} from '@pass-frontend/common/constants/paths';
import { useIntl } from '@pass-frontend/common/i18n';
import { env } from '@pass-frontend/features/configuration/util';
import { eligibilityLookupSlice } from '@pass-frontend/features/facility-checkin/data-access';
import {
  MemberCheckModuleLoader,
  useCurrenEligibilityCheck,
} from '@pass-frontend/features/facility-checkin/data-bridge';
import { RdsButton } from '@pass-frontend/rally-energon-react';
import { RESPONSIVE_QUERY } from '@pass-frontend/utility/style-helpers';

import { FacilityHeader } from '../facility-header/facility-header';
import { LocationSearch } from '../location-search/location-search';
import { MemberDetails } from '../member-details/member-details';

const MemberInfoWrapper = styled.div`
  width: 1272px;
  margin: 0 auto;

  ${RESPONSIVE_QUERY.large} {
    width: 90%;
  }
`;

const BoxContent = styled.div`
  max-width: 840px;
`;

export const MemberInfo = () => {
  const router = useRouter();
  const { t } = useIntl();
  const dispatch = useDispatch();
  const { ENABLE_FACILITY_CODE_CHECK } = env();
  const backToCheckinClick = () => router?.push('/');
  const { memberDetails } = useCurrenEligibilityCheck();

  useEffect(() => {
    if (!memberDetails) {
      router?.push(DASHBOARD_PATH);
    } else {
      dispatch(eligibilityLookupSlice.actions.resetLocationGymsFilter());
    }
  }, [memberDetails]);

  return (
    <>
      <FacilityHeader />
      <div className="has-rds-bg-grey-lightest has-rds-pb-64">
        <MemberInfoWrapper className="has-rds-pv-40 ">
          <MemberCheckModuleLoader>
            <BoxContent>
              <MemberDetails memberDetails={memberDetails} />
              <div className=" has-rds-mt-24">
                <RdsButton onClick={backToCheckinClick}>
                  {t('facilityWeb.newMemberSearch')}
                </RdsButton>
              </div>
              {ENABLE_FACILITY_CODE_CHECK && (
                <div className=" has-rds-mt-24">
                  <LocationSearch
                    redirectTo={FACILITY_PATHS.LOCATION_SEARCH_RESULTS}
                  />
                </div>
              )}
            </BoxContent>
          </MemberCheckModuleLoader>
        </MemberInfoWrapper>
      </div>
    </>
  );
};

export default MemberInfo;
